// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__11x0H","description":"PatientConsentPreview_description__1xySM"};